(() => {

  const MAX_PROBABILITY = 100;
  const CYCLE_LENGTH = 28;

  const getCurrencySign  = () => {
    return '&euro;';
  };

  const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');

    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.classList.add('chart-js-tooltip-el');
      chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
  };

  const getValidValue = input => {
    let value = parseInt(input.value);
    let min = typeof(input.dataset.min) !== 'undefined' ? parseInt(input.dataset.min) : null;
    let max = typeof(input.dataset.max) !== 'undefined' ? parseInt(input.dataset.max) : null;

    if (Number.isNaN(value)) {
      value = 0;
    }

    if (min !== null && value < min) {
      value = min;
    }

    if (max !== null && value > max) {
      value = max;
    }

    return value;
  };

  const externalTooltipHandler = (context) => {
    // Tooltip Element
    const {chart, tooltip} = context;
    const tooltipEl = getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    // Set Text
    if (tooltip.body) {
      const titleLines = tooltip.title || [];
      const bodyLines = tooltip.body.map(b => b.lines);

      tooltipEl.innerHTML = `${app.number_format(tooltip.dataPoints[0].raw.price, 0, ',', '.')} ${getCurrencySign()}`
    }

    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  };

  const getCalculatedData = (successRate, treatmentCost, strawCost, desiredSuccessRate, times) => {
    const failureRate = Math.abs(1 - successRate);
    const cycles = [];
    const maxCycles = 100;
    let currentCycle = 1;
    let currentProbability = 0;

    while (true) {
      currentProbability = (1 - Math.pow(failureRate, currentCycle)) * 100;

      if (currentProbability > MAX_PROBABILITY) {
        currentProbability = MAX_PROBABILITY;
      }

      cycles.push({
        x: currentCycle,
        y: currentProbability,
        cycle: currentCycle,
        probability: currentProbability,
        price: (treatmentCost + strawCost) * currentCycle
      });

      if (times && currentCycle === times) {
        break;
      } else if (!times && currentProbability >= desiredSuccessRate) {
        break;
      }

      currentCycle++;

      if (currentCycle > maxCycles) {
        break;
      }
    }

    return cycles;
  }

  const getSelfInseminationData = (calculator, times)=> {
    const checkbox = calculator.querySelector('[name="method_self"]');

    if (!checkbox || !checkbox.checked) {
      return null;
    }

    return getCalculatedData(
      getValidValue(calculator.querySelector('[name="method_self_rate"]')) * 0.01,
      getValidValue(calculator.querySelector('[name="method_self_cost"]')),
      getValidValue(calculator.querySelector('[name="straw_cost"]')),
      getValidValue(calculator.querySelector('[name="success"]')),
      times
    );
  }

  const getIUIData = (calculator, times)=> {
    const checkbox = calculator.querySelector('[name="method_iui"]');

    if (!checkbox || !checkbox.checked) {
      return null;
    }

    return getCalculatedData(
      getValidValue(calculator.querySelector('[name="method_iui_rate"]')) * 0.01,
      getValidValue(calculator.querySelector('[name="method_iui_cost"]')),
      getValidValue(calculator.querySelector('[name="straw_cost"]')),
      getValidValue(calculator.querySelector('[name="success"]')),
      times
    );
  }

  const getIVFData = (calculator, times)=> {
    const checkbox = calculator.querySelector('[name="method_ivf"]');

    if (!checkbox || !checkbox.checked) {
      return null;
    }

    return getCalculatedData(
      getValidValue(calculator.querySelector('[name="method_ivf_rate"]')) * 0.01,
      getValidValue(calculator.querySelector('[name="method_ivf_cost"]')),
      getValidValue(calculator.querySelector('[name="straw_cost"]')),
      getValidValue(calculator.querySelector('[name="success"]')),
      times
    );
  }

  const buildTable = (calculator, selfData, iuiData, ivfData) => {
    const success = getValidValue(calculator.querySelector('[name="success"]'));
    const container = calculator.querySelector('.treatment-calculator-table-container');
    container.innerHTML = `
      <table class="treatment-calculator-table">
        <thead>
          <tr>
            <td></td>
            <td class="${!selfData ? 'off' : ''}">${window.treatmentCalculatorStrings.self_insemination}</td>
            <td class="${!iuiData ? 'off' : ''}">IUI</td>
            <td class="${!ivfData ? 'off' : ''}">IVF</td>
          </tr>
        </thead>
        <tbody>
          <tr class="treatment-calculator-table-row first">
            <td>${window.treatmentCalculatorStrings.number_to_achieve}</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr class="treatment-calculator-table-row second">
            <td>${window.treatmentCalculatorStrings.average_costs}</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
          </tr>
        </tbody>
      </table>`;

    if (selfData) {
      let selfCycles = 1;
      let selfSet = false;
      let selfCost = 0;

      selfData.forEach(data => {
        if (!selfSet && data.probability >= success) {
          selfCycles = data.cycle;
          selfCost = data.price;
          selfSet = true;
        }
      });

      let selfDays = selfCycles * CYCLE_LENGTH;
      container.querySelector('.first td:nth-child(2)').innerHTML = `
        <span class="treatment-calculator-table-cycles">${window.treatmentCalculatorStrings.cycles_amount.replace(':amount', selfCycles)}</span>
        <span class="treatment-calculator-table-days">${window.treatmentCalculatorStrings.average_days.replace(':amount', selfDays)}</span>
      `;
      container.querySelector('.second td:nth-child(2)').innerHTML = `
        <span class="treatment-calculator-table-cost">${app.number_format(selfCost, 0, '', '.')} ${getCurrencySign()}</span>
      `;
    }

    if (iuiData) {
      let iuiCycles = 1;
      let iuiSet = false;
      let iuiCost = 0;

      iuiData.forEach(data => {
        if (!iuiSet && data.probability >= success) {
          iuiCycles = data.cycle;
          iuiCost = data.price;
          iuiSet = true;
        }
      });

      let iuiDays = iuiCycles * CYCLE_LENGTH;

      container.querySelector('.first td:nth-child(3)').innerHTML = `
        <span class="treatment-calculator-table-cycles">${window.treatmentCalculatorStrings.cycles_amount.replace(':amount', iuiCycles)}</span>
        <span class="treatment-calculator-table-days">${window.treatmentCalculatorStrings.average_days.replace(':amount', iuiDays)}</span>
      `;
      container.querySelector('.second td:nth-child(3)').innerHTML = `
        <span class="treatment-calculator-table-cost">${app.number_format(iuiCost, 0, '', '.')} ${getCurrencySign()}</span>
      `;
    }

    if (ivfData) {
      let ivfCycles = 1;
      let ivfSet = false;
      let ivfCost = 0;

      ivfData.forEach(data => {
        if (!ivfSet && data.probability >= success) {
          ivfCycles = data.cycle;
          ivfCost = data.price;
          ivfSet = true;
        }
      });

      let ivfDays = ivfCycles * CYCLE_LENGTH;

      container.querySelector('.first td:nth-child(4)').innerHTML = `
        <span class="treatment-calculator-table-cycles">${window.treatmentCalculatorStrings.cycles_amount.replace(':amount', ivfCycles)}</span>
        <span class="treatment-calculator-table-days">${window.treatmentCalculatorStrings.average_days.replace(':amount', ivfDays)}</span>
      `;
      container.querySelector('.second td:nth-child(4)').innerHTML = `
        <span class="treatment-calculator-table-cost">${app.number_format(ivfCost, 0, '', '.')} ${getCurrencySign()}</span>
      `;
    }
  }

  const calculate = calculator => {
    let selfData = getSelfInseminationData(calculator);
    let iuiData = getIUIData(calculator);
    let ivfData = getIVFData(calculator);
    let maxCycles = 1;

    if (selfData) {
      selfData.forEach(data => {
        if (data.cycle > maxCycles) {
          maxCycles = data.cycle;
        }
      });
    }

    if (iuiData) {
      iuiData.forEach(data => {
        if (data.cycle > maxCycles) {
          maxCycles = data.cycle;
        }
      });
    }

    if (ivfData) {
      ivfData.forEach(data => {
        if (data.cycle > maxCycles) {
          maxCycles = data.cycle;
        }
      });
    }

    selfData = getSelfInseminationData(calculator, maxCycles);
    iuiData = getIUIData(calculator, maxCycles);
    ivfData = getIVFData(calculator, maxCycles);

    const labels = [];

    for (let i = 1; i <= maxCycles; i++) {
      labels.push('' + i);
    }

    const chartDiv = calculator.querySelector('.treatment-calculator-chart');
    const canvas = chartDiv.querySelector('canvas');

    const data = {
      labels: labels,
      datasets: []
    };

    if (selfData) {
      data.datasets.push({
        label: 'Self Insemination',
        borderColor: '#899C80',
        backgroundColor: '#899C80',
        pointStyle: 'circle',
        pointRadius: 10,
        pointHoverRadius: 15,
        pointBorderColor: '#756E6B',
        cubicInterpolationMode: 'monotone',
        data: selfData
      });
    }

    if (iuiData) {
      data.datasets.push({
        label: 'IUI',
        borderColor: '#C87D60',
        backgroundColor: '#C87D60',
        pointStyle: 'circle',
        pointRadius: 10,
        pointHoverRadius: 15,
        pointBorderColor: '#756E6B',
        cubicInterpolationMode: 'monotone',
        data: iuiData
      });
    }

    if (ivfData) {
      data.datasets.push({
        label: 'IVF',
        borderColor: '#F4DDCB',
        backgroundColor: '#F4DDCB',
        pointStyle: 'circle',
        pointRadius: 10,
        pointHoverRadius: 15,
        pointBorderColor: '#756E6B',
        cubicInterpolationMode: 'monotone',
        data: ivfData
      });
    }

    if (!canvas.id) {
      canvas.id = Date.now().toString(36) + Math.random().toString(36).substring(2);
    }

    let chartStatus = Chart.getChart(canvas.id);

    if (chartStatus !== undefined) {
      chartStatus.destroy();
    }

    calculator.classList.add('calculated');

    const success = getValidValue(calculator.querySelector('[name="success"]'));
    console.log('addin annotation', success);
    //Chart.register(ChartAnnotation.Annotation);
    //Chart.register(a);
    const chart = new Chart(canvas, {
      type: 'line',
      data: data,
      options: {
        intersection: {
          mode: 'point'
        },
        responsive: true,
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: window.treatmentCalculatorStrings.chart_x_label
            },
            ticks: {
              maxTicksLimit: 8
            }
          },
          y: {
            display: true,
            title: {
              display: true,
              text: window.treatmentCalculatorStrings.chart_y_label
            },
            suggestedMin: 10,
            suggestedMax: 100,
            ticks: {
              stepSize: 20,
              callback: function (value, index, ticks) {
                if (value == 100) {
                  return '';
                }

                return value + '%';
              }
            }
          }
        },
        plugins: {
          tooltip: {
            enabled: false,
            external: externalTooltipHandler
          },
          annotation: {
            annotations: {
              customLine: {
                type: 'line',
                yMin: success,
                yMax: success,
                borderColor: '#cebfb4',
                borderWidth: 2,
                drawTime: 'beforeDatasetsDraw',
                label: {
                  display: true,
                  content: success + '%',
                  position: 'end',
                  color: '#756E6B',
                  backgroundColor: '#ffeddf',
                }
              }
            }
          }
        }
      }
    });

    buildTable(calculator, selfData, iuiData, ivfData);

    calculator.querySelector('.treatment-calculator-chart').scrollIntoView({
      behavior: 'smooth'
    });
  };

  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.treatment-calculator').forEach(calculator => {
      calculator.querySelectorAll('.treatment-calculator-form-method').forEach(method => {
        const checkbox = method.querySelector('input[type="checkbox"]');

        checkbox.addEventListener('change', e => {
          if (checkbox.checked) {
            method.classList.remove('off');
            method.querySelectorAll('input[type="text"]').forEach(text => {
              text.classList.remove('disabled');
              text.disabled = false;
            });
          } else {
            method.classList.add('off');
            method.querySelectorAll('input[type="text"]').forEach(text => {
              text.classList.add('disabled');
              text.disabled = true;
            });
          }
        });
      });

      calculator.querySelectorAll('input[type="text"]').forEach(input => {
        input.addEventListener('keypress', e => {
          const theEvent = e || window.event;
          let key = null;

          // Handle paste
          if (theEvent.type === 'paste') {
            key = event.clipboardData.getData('text/plain');
          } else {
            key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
          }

          const regex = /[0-9]|\./;

          if (!regex.test(key) ) {
            theEvent.returnValue = false;

            if (theEvent.preventDefault) {
              theEvent.preventDefault();
            }
          }
        });

        ['blur', 'change'].forEach(event => input.addEventListener(event, e => {
          input.value = getValidValue(input);
        }));
      });

      calculator.querySelector('.treatment-calculator-form-submit button').addEventListener('click', e => {
        e.preventDefault();

        calculate(calculator);
      });
    });
  })
})();